/**
 * Persist utm_* and webflow query params into sessionStorage so they survive
 * navigation and can be read by setQueryParams / scheduleAppointment.
 *
 * Only writes when the key is not already set (first-touch attribution).
 *
 * @param {string} [search] - location.search (with or without leading ?)
 */
const persistMarketingQueryParams = (search) => {
  if (!search || typeof sessionStorage === 'undefined') return

  const params = new URLSearchParams(
    search.startsWith('?') ? search.slice(1) : search
  )

  if (sessionStorage.getItem('utm') === null) {
    const utmPairs = []
    params.forEach((value, key) => {
      if (key.startsWith('utm_')) {
        utmPairs.push(`${key}=${encodeURIComponent(value)}`)
      }
    })
    if (utmPairs.length > 0) {
      sessionStorage.setItem('utm', utmPairs.join('&'))
    }
  }

  if (sessionStorage.getItem('webflow') === null && params.has('webflow')) {
    sessionStorage.setItem(
      'webflow',
      `webflow=${encodeURIComponent(params.get('webflow'))}`
    )
  }
}

export default persistMarketingQueryParams
